import React from "react";

const PILLARS = [
  {
    label: "Work",
    color: "#017bef",
    image: "/figma-assets/home/what-work.jpg",
    // Only the Work image shows the gradient in the design; the other two photos sit above it
    gradient: true,
    items: ["Coworking spaces", "Dedicated desks", "Meeting rooms", "Conference rooms", "Private offices"],
  },
  {
    label: "Stay",
    color: "#0062c0",
    image: "/figma-assets/home/what-stay.jpg",
    gradient: false,
    items: ["Hotels", "Serviced apartments", "Boutique hotels"],
  },
  {
    label: "Play",
    color: "#0ea5e9",
    image: "/figma-assets/home/what-play.jpg",
    gradient: false,
    items: ["Wellness centres", "Dining venues", "Adventure experiences", "Events"],
  },
];

export default function WhatIsSpaciaSection() {
  return (
    <section className="relative overflow-hidden bg-[#012d6e] py-20">
      <div className="pointer-events-none absolute right-0 top-0 h-[400px] w-[600px] rounded-full bg-[#017bef]/15 blur-[64px]" />
      <div className="pointer-events-none absolute bottom-0 left-0 h-[300px] w-[400px] rounded-full bg-[#0062c0]/10 blur-[64px]" />

      <div className="relative mx-auto max-w-[1440px] px-[16px] sm:px-8">
        <div className="flex flex-col items-center text-center">
          <span className="rounded-full border-[1px] border-solid border-white/15 bg-white/10 px-[16px] py-1.5 text-[12px] font-semibold uppercase leading-4 tracking-[1.2px] text-white/70">
            The Platform
          </span>
          <h2 className="pt-[20px] text-[36px] font-bold leading-[48px] tracking-[-1.2px] text-white sm:text-[48px]">
            What is SPACIA?
          </h2>
          <p className="max-w-[672px] pt-[20px] text-[18px] leading-[29.25px] text-white/60">
            SPACIA is a platform that connects people to flexible workspaces, quality accommodation and curated
            lifestyle experiences all in one place.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-[20px] pt-14 md:grid-cols-3">
          {PILLARS.map(pillar => (
            <div
              key={pillar.label}
              className="flex flex-col overflow-hidden rounded-3xl border-[1px] border-solid border-white/10"
            >
              <div className="relative h-44">
                <img src={pillar.image} alt={pillar.label} className="absolute inset-0 size-full object-cover" />
                {pillar.gradient && <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />}
                <span
                  className="absolute left-4 top-4 rounded-full px-[12px] py-1 text-[12px] font-bold uppercase leading-4 tracking-[1.2px] text-white"
                  style={{ backgroundColor: pillar.color }}
                >
                  {pillar.label}
                </span>
              </div>
              <ul className="flex-1 space-y-2 bg-white/5 p-[20px]">
                {pillar.items.map(item => (
                  <li key={item} className="flex items-center gap-2 text-[14px] leading-5 text-white/70">
                    <span className="size-1.5 shrink-0 rounded-full" style={{ backgroundColor: pillar.color }} />
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="relative mt-10 overflow-hidden rounded-3xl border-[1px] border-solid border-white/10 bg-white/5 px-6 py-10 text-center sm:px-10">
          <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-[#60a5fa]/0 via-[#60a5fa]/40 to-[#60a5fa]/0" />
          <p className="text-[12px] font-semibold uppercase leading-4 tracking-[1.2px] text-white/50">
            One booking. One account. Everything in one place.
          </p>
          <p className="mx-auto max-w-[768px] pt-[16px] text-[20px] font-semibold leading-[1.6] text-white sm:text-[24px] sm:leading-[39px]">
            Through three connected pillars — Work, Stay and Play — SPACIA makes it possible to book a coworking desk, a
            hotel room and a dinner reservation without ever leaving the platform.
          </p>
        </div>
      </div>
    </section>
  );
}
